import * as React from "react";
import { Separator } from "@/components/ui/separator";
export default function ResourcesOverview() {
  return <section id="resources-overview" className="relative flex min-h-[70vh] flex-col items-center justify-center overflow-hidden bg-foreground px-6 py-24 text-background">
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: `linear-gradient(to right, var(--color-background) 1px, transparent 1px), linear-gradient(to bottom, var(--color-background) 1px, transparent 1px)`,
      backgroundSize: "4rem 4rem"
    }} />

      {}
      {}
      <div className="relative z-10 flex w-full max-w-5xl flex-col items-center border border-primary/20 bg-primary p-10 text-center backdrop-blur-md md:p-20">
        {}
        <div className="absolute -left-[1px] -top-[1px] h-4 w-4 border-l border-t border-background/40" />
        <div className="absolute -right-[1px] -top-[1px] h-4 w-4 border-r border-t border-background/40" />
        <div className="absolute -bottom-[1px] -left-[1px] h-4 w-4 border-b border-l border-background/40" />
        <div className="absolute -bottom-[1px] -right-[1px] h-4 w-4 border-b border-r border-background/40" />

        <h1 className="mb-8 font-default text-5xl font-extrabold uppercase leading-none tracking-wider md:text-7xl lg:text-[5rem]">
          Resources
        </h1>

        <Separator className="mb-8 h-[2px] w-[200px] bg-primary" />

        <p className="max-w-2xl font-sans text-lg font-medium leading-relaxed text-background/80 md:text-xl">
          Explore our capability statement and learn how to express your interest in partnering with us. We are committed to service and delivering excellence across all construction industry sectors.
        </p>
      </div>
    </section>;
}